import { Validator } from "shared/lib/validator.lib";

export const seaSearchValueValidator = new Validator<string>();
seaSearchValueValidator.addRule({
  name: "minLength",
  validate: (value) => value.length >= 6,
  errorMessage: "Please, enter at least 6 characters",
});
seaSearchValueValidator.addRule({
  name: "maxLength",
  validate: (value) => (value.includes("/") ? value.length <= 30 : value.length <= 20),
  errorMessage: "Please enter 20 characters at most (or 30 characters if a slash is included).",
});
seaSearchValueValidator.addRule({
  name: "checkSymbols",
  validate: (value) => /^[a-zA-Z0-9./-]*$/.test(value),
  errorMessage: `Please enter only Latin characters, numbers and symbols ("." , "/" , "-").'`,
});

export const airSearchValueValidator = new Validator<string>();

airSearchValueValidator.addRule({
  name: "validate",
  validate: (value) => {
    const [_, numberWithoutPrefix] = value.split("-");
    const simpleCheck = /^\d{3}-\d{8}$/.test(value);
    if (simpleCheck) {
      const lastDigit = parseInt(numberWithoutPrefix.slice(-1));
      const awbNumberWithoutChecksum = parseInt(numberWithoutPrefix.slice(0, -1));
      const remainder = awbNumberWithoutChecksum % 7;
      if (remainder === lastDigit) {
        return true;
      }
    }
    return false;
  },
  errorMessage: "The air waybill number should have the format 123-12345675",
});

export const railSearchValueValidator = new Validator<string>();

railSearchValueValidator.addRule({
  name: "required",
  validate: (value) => !!value,
  errorMessage: "The tracking number is required",
});

railSearchValueValidator.addRule({
  name: "letters-digits",
  validate: (value) => /^[a-zA-Z0-9]+$/gi.test(value),
  errorMessage: "The tracking number must contain letters and digits only",
});

export const roadSearchValueValidator = new Validator<string>();

roadSearchValueValidator.addRule({
  name: "required",
  validate: (value) => !!value,
  errorMessage: "The tracking number is required",
});

roadSearchValueValidator.addRule({
  name: "letters-digits-hyphens",
  validate: (value) => /^[a-zA-Z0-9-]+$/gi.test(value),
  errorMessage: "The tracking number must contain letters, digits and hyphens only",
});

export const parcelSearchValueValidator = new Validator<string>();

parcelSearchValueValidator.addRule({
  name: "required",
  validate: (value) => !!value,
  errorMessage: "The tracking number is required",
});

parcelSearchValueValidator.addRule({
  name: "letters-digits-hyphens",
  validate: (value) => /^[a-zA-Z0-9-]+$/gi.test(value),
  errorMessage: "The tracking number must contain letters, digits and hyphens only",
});
